import * as ip from "../utils/ip";

module.exports = class ipv6Address {
    getState() {
        return ip.getV6Data();
    }
};



// WEBPACK FOOTER //
// ./frontend/connection_tests/ipv6Address.js